import "./Panels.css"

type Props = {
  imgContent?: string;
};

const ImageCollage: React.FC<Props> = ({ imgContent = '/assets/images/home-gallery.png' }) => {
  return (
    <div className="mix">
      <img
        src={imgContent}
        className="mix-image"
        alt="the collage of images from the home gallery"
      />
    </div>
  );
};

export default ImageCollage;